<template>
  <el-select
    v-model="selectValue"
    :class="[className]"
    :multiple="multiple"
    :collapse-tags="collapseTags"
    :clearable="clearable"
    :filterable="filterable"
    :placeholder="placeholder"
    :value="value"
    :default-first-option="false"
    :filter-method="handleFilterMethod"
    :reserve-keyword="reserveKeyword"
    :remote="remote"
    :loading="loading"
    :size="size"
    :remote-method="handleRemoteMethod"
    @visible-change="handleVisibleChange"
    @keyup.native.13.stop="handleKeyup"
  >
    <template v-if="!blurry">
      <el-option
        :value="String('')"
        disabled
      >
        <el-button type="text" size="mini" @click="selectAll">全选</el-button>
      </el-option>
      <el-option
        v-if="input && input.includes(',') && ((filterOptions || options).length || createdOptions.length)"
        :value="String('')"
        disabled
      >
        <span class="point">试试回车</span>
      </el-option>
      <el-option
        v-if="hasAll"
        :label="allName"
        :value="allValue"
      />
      <el-option
        v-for="key in createdOptions"
        :key="key"
        :label="key"
        :value="key"
      />
      <el-option
        v-for="item in (filterOptions || options)"
        :key="item[valueName]"
        :label="item[labelName]"
        :value="multiple ? String(item[valueName]) : item[valueName]"
        class="dropdown-value-item"
      >
        <span class="dropdown-value-item-text">{{ item[labelName] }}</span>
        <span
          v-if="showValue"
          class="dropdown-value-item-key"
        >
          {{ item[valueName] === allValue ? '' : item[valueName] }}
        </span>
      </el-option>
    </template>
    <template v-else>
      <el-option-group
        v-if="input"
        label="模糊搜索"
      >
        <el-option
          :label="input"
          value=""
        />
      </el-option-group>
      <el-option-group :label="input ? '精确搜索' : ''">
        <el-option
          v-for="item in options"
          :key="item[valueName]"
          :label="item[labelName]"
          :value="multiple ? String(item[valueName]) : item[valueName]"
        />
      </el-option-group>
    </template>
  </el-select>
</template>

<script>
import { findIndex } from 'lodash';
export default {
  props: {
    value: {
      default: () => [],
    },
    options: {
      default: () => [],
    },
    multiple: {
      default: true,
    },
    clearable: {
      default: true,
    },
    filterable: {
      default: false,
    },
    reserveKeyword: {
      default: false,
    },
    placeholder: {
      default: '',
    },
    hasAll: {
      default: true,
    },
    allValue: {
      default: '',
    },
    allName: {
      default: '全部',
    },
    valueName: {
      default: 'id',
    },
    labelName: {
      default: 'name',
    },
    className: {
      default: '',
    },
    filterMethod: {
      default: null,
    },
    remote: {
      default: false,
    },
    loading: {
      default: false,
    },
    remoteMethod: {
      default: null,
    },
    showValue: {
      default: false,
    },
    collapseTags: {
      default: true,
    },
    blurry: {
      default: false,
    },
    allowCreate: {
      default: false,
    },
    size: {
      default: 'small'
    }
  },
  data() {
    return {
      isAll: false,
      input: '',
      isBlurry: false,
      filterOptions: null,
    };
  },
  computed: {
    selectValue: {
      get() {
        let val = this.value;
        if (!val && val !== 0) {
          val = this.multiple ? [] : '';
        }
        if (this.isAll) {
          if (this.multiple && (!val || !val.length)) {
            val = [this.allValue];
          }
          if (!this.multiple && !val && val !== 0) {
            val = this.allValue;
          }
        }
        return val;
      },
      set(val) {
        let value = val;
        if (this.blurry) {
          if (value.includes('') && (!this.value || !this.value.includes(''))) {
            this.isBlurry = true;
            value = [''];
            this.$emit('input', value);
            this.$emit('change', value, this.input);
            return;
          } else {
            this.isBlurry = false;
            value = val.filter((v) => v !== '');
          }
        }
        if (this.multiple) {
          // 多选
          if (this.hasAll) {
            // 包含全部
            if (value.includes(this.allValue) && !this.isAll) {
              this.isAll = true;
              value = [];
            } else {
              this.isAll = false;
              value = value.filter((v) => v !== this.allValue);
            }
          }
        } else {
          // 单选
          if (this.hasAll && value === this.allValue) {
            // 包含全部
            this.isAll = true;
            value = '';
          } else {
            this.isAll = false;
          }
        }
        this.$emit('input', value);
        this.$emit('change', value);
      },
    },
    createdOptions() {
      if (this.allowCreate && this.input) {
        let options = this.input.split(',');
        options = options.filter(
          (key) =>
            key && findIndex(this.options, { [this.valueName]: key }) === -1,
        );
        return [...new Set(options)];
      }
      return [];
    },
  },
  methods: {
    handleFilterMethod(v) {
      console.log('v', v)
      let value = v;
      value = (value || '').replace(/(^\s*)|(\s*$)/g, '');
      this.input = value;
      console.log(this.input);
      if (this.filterMethod) {
        this.filterOptions = null;
        this.filterMethod(value);
      } else {
        let filterOptions = null;
        if (value && value.includes(',')) {
          this.adsrcId = value;
          value = `,${value},`.toUpperCase();
          filterOptions = this.options.filter(
            (item) =>
              value.includes(`,${item[this.valueName]},`) ||
              value.includes(`,${item[this.labelName].toUpperCase()},`),
          );
        } else if (value) {
          filterOptions = this.options.filter(
            (item) =>
              item[this.valueName].includes(value) ||
              item[this.labelName].toUpperCase().includes(value.toUpperCase()),
          );
        }
        this.filterOptions = filterOptions;
      }
    },
    handleRemoteMethod(v) {
      if (!v) return
      let value = v;
      value = (value || '').replace(/(^\s*)|(\s*$)/g, '');
      this.input = value;
      this.remoteMethod && this.remoteMethod(value);
    },
    handleKeyup() {
      if (!this.multiple) return;
      let selectValue = [...this.selectValue];
      const options =
        this.filterOptions && this.filterOptions.length
          ? this.filterOptions
          : this.options;
      options.forEach((o) => {
        const val = String(o[this.valueName]);
        if (!this.selectValue.includes(val)) {
          selectValue.push(val);
        }
      });
      if (this.allowCreate) {
        selectValue = this.createdOptions
          .filter((v) => !selectValue.includes(v))
          .concat(selectValue);
      }
      if (this.input && this.input.includes(',')) {
        this.selectValue = selectValue;
      }
    },
    handleVisibleChange() {
      this.filterOptions = null;
      this.$emit('visible-change', ...arguments);
    },
    selectAll() {
      let selectValue = [
        ...this.selectValue
      ];
      const options = [
        ...(this.filterOptions || this.options)
      ]
      options.forEach(item => {
        selectValue.push(String(item[this.valueName]))
      })
      this.selectValue = [
        ...new Set(selectValue)
      ];
    }
  },
};
</script>
